import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsDefined, IsNumber, IsOptional, IsString, MaxLength, Min, MinLength, ValidateNested } from 'class-validator';
import { StoreExposeGroup } from '../interface';
import { PatchAbstractStoreDelayedOrdersDto } from './PatchAbstractStoreDelayedOrdersDto';
export class PatchStorePickupDto {
    constructor() {
        this.isUsingStoreLocationAddress = false;
    }
}
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], PatchStorePickupDto.prototype, "isEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 20, minimum: 0 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], PatchStorePickupDto.prototype, "time", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 255, example: '150 W 65th St, New York, NY 10023' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.CREATE, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.PATCH] }),
    MinLength(3, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    MaxLength(255, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsString({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStorePickupDto.prototype, "address", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.CREATE, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], PatchStorePickupDto.prototype, "isUsingStoreLocationAddress", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], PatchStorePickupDto.prototype, "isTipRequired", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 15, minimum: 0 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Min(0, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], PatchStorePickupDto.prototype, "minOrderTotal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 200, minimum: 0 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Min(0, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], PatchStorePickupDto.prototype, "maxOrderTotal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchAbstractStoreDelayedOrdersDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchAbstractStoreDelayedOrdersDto),
    __metadata("design:type", PatchAbstractStoreDelayedOrdersDto)
], PatchStorePickupDto.prototype, "delayedOrders", void 0);
//# sourceMappingURL=PatchStorePickupDto.js.map